import { render, staticRenderFns } from "./BetSuggested.vue?vue&type=template&id=58d6f7f9&scoped=true&"
import script from "./BetSuggested.vue?vue&type=script&lang=js&"
export * from "./BetSuggested.vue?vue&type=script&lang=js&"
import style0 from "./BetSuggested.vue?vue&type=style&index=0&id=58d6f7f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6f7f9",
  null
  
)

export default component.exports